import styles from './FJAudioPresetItem.module.less';
import FJUtil from '../../../../util/FJUtil.js';
import { useState, useRef } from 'react';
import classNames from 'classnames';
import FJPlayIcon from '../../../../assets/svg/play.svg?react';
import FJPauseIcon from '../../../../assets/svg/pause.svg?react';
import FJAudioPlayManager from '../../../../store/FJAudioPlayManager.js';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJResourceItemLoading from '../../../../common/components/FJResourceItemLoading/FJResourceItemLoading.jsx';
import FJMessageStore from '../../../../store/FJMessageStore.js';
import FJStarIcon from '../../../../assets/svg/re-star.svg?react';
import PropTypes from 'prop-types';

const FJAudioPresetItem = props => {
    const { item, onUse, setIsOpenSwiper } = props;
    const { audioUrl, coverUrl, time, onClickItem } = item;
    const [currentTime, setCurrentTime] = useState(0);
    const audioRef = useRef(null);
    const _timer = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [useAudioUrl, setUseAudioUrl] = useState(audioUrl);
    const [isCoverLoading, setIsCoverLoading] = useState(true);
    const [audioDuration, setAudioDuration] = useState(0);

    const idRef = useRef(FJAudioPlayManager.createId());
    const presetRef = useRef(null);
    const isMouseIn = useRef(false);

    const _onClickItem = () => {
        onClickItem(presetRef.current.getBoundingClientRect());
    };

    const clearProgressTimer = () => {
        if (_timer.current) {
            clearInterval(_timer.current);
            setCurrentTime(0);
        }
    };

    const updateProgress = () => {
        clearProgressTimer();
        _timer.current = setInterval(() => {
            try {
                setCurrentTime(audioRef.current.currentTime);
            } catch (e) {
                console.log(e);
                clearProgressTimer();
            }
        }, 40);
    };

    const _onUse = e => {
        e.stopPropagation();
        onUse();
    };

    const play = () => {
        FJAudioPlayManager.add(idRef.current, { pause: pause });
        audioRef.current.play();
        updateProgress();
        setIsPlaying(true);
        setIsOpenSwiper(false);
    };

    const pause = () => {
        audioRef.current.pause();
        clearProgressTimer();
        setIsPlaying(false);
        setIsOpenSwiper(true);
    };

    const onSwitchPlay = () => {
        _onClickItem();
        setIsPlaying(!isPlaying);
        setIsOpenSwiper(true);
        if (isPlaying) {
            pause();
        } else {
            if (setIsError) {
                setIsLoading(true);
                setUseAudioUrl(FJUtil.getReloadNewUrl(useAudioUrl));
            } else {
                play();
            }
        }
    };

    const onEnded = () => {
        setIsPlaying(false);
        pause();
    };

    const onLoadedData = () => {
        setIsError(false);
        setIsLoading(false);
        setAudioDuration(audioRef.current.duration);
    };

    const onLoadStart = () => {
        setIsLoading(true);
        setIsError(false);
        if (isPlaying) {
            play();
        }
    };

    const onError = () => {
        setIsError(true);
        setIsLoading(false);
        if (isPlaying) {
            setIsPlaying(false);
            setIsOpenSwiper(true);
            FJMessageStore.addMessage(FJLocalStore._('playback-failed-please-try-again'), 'error');
        }
    };

    const _sourceLoaded = () => {
        setIsCoverLoading(false);
    };

    const _sourceError = () => {
        setIsCoverLoading(false);
    };

    const onMouseEnter = () => {
        isMouseIn.current = true;
    };

    const onMouseLeave = () => {
        isMouseIn.current = false;
    };

    return (
        <div
            className={classNames(styles.box, isPlaying ? styles.active : '')}
            onClick={onSwitchPlay}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            ref={presetRef}
        >
            <img src={coverUrl} alt='' className={styles.img_box} onLoad={_sourceLoaded} onError={_sourceError} />
            {isCoverLoading && <FJResourceItemLoading />}
            <div className={styles.top}>
                <div className={styles.title}>{item.name}</div>
                <div className={styles.type}>{FJLocalStore._(item.useStyle)}</div>
            </div>
            <div className={styles.center}>
                {isLoading && <div className={styles.loading}></div>}
                {isPlaying ? <FJPauseIcon /> : <FJPlayIcon />}
            </div>
            <div className={styles.bottom}>
                <div className={styles.btn} onClick={_onUse}>
                    <FJStarIcon />
                    {FJLocalStore._('remix')}
                </div>
                <div className={styles.time}>
                    {FJUtil.formatTime(currentTime, undefined, 2)}/
                    {FJUtil.formatTime(audioDuration || time, undefined, 2)}
                </div>
            </div>
            <audio
                src={useAudioUrl}
                ref={audioRef}
                onEnded={onEnded}
                onError={onError}
                onLoadedData={onLoadedData}
                onLoadStart={onLoadStart}
            />
        </div>
    );
};

FJAudioPresetItem.propTypes = {
    item: PropTypes.object,
    onUse: PropTypes.func,
    setIsOpenSwiper: PropTypes.func,
};
export default FJAudioPresetItem;
